export default{
    __bsi_SeeAll:"Login untuk melihat semua"
}